export enum ParticipationMethod {
    Surveys = 1,
    Tests = 2,
    OnsiteAtCustomer = 3,
    OnsiteAtEconomic = 4,
}

export enum InterestArea {
    InventoryFeedbackGroup = 1,
}

export interface UserPanelRegistrationInformation {
    name: string;
    email: string;
    phone: string;
    city: string;
    languages: string[];
    participation: ParticipationMethod[];
    interestAreas: InterestArea[];
    userGuid: string;
    jobRole: string;
}

export interface UserPanelRegistrationDetails {
    name: string;
    email: string;
    phone: string;
    city: string;
    jobRole: string;
    languages: string[];
    participation: ParticipationMethod[];
    interestAreas: InterestArea[];
    dateJoined: Date;
    userGuid: string;
    note: string;
    agreementNo: number;
    userId: string;
    userType: string;
    subscription: number;
    companyName: string;
    cvr: string;
}

export interface UserPanelNote {
    userGuid: string;
    note: string;
}
